// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper___UGvhS","button":"styles-module__button___3t2Ct","panels":"styles-module__panels___cX3rm"};